import {
  GET_ALL_ROLES,
  GET_ROLE
} from 'src/store/mutation-types'

export default {
  [GET_ALL_ROLES] (state, roles) {
    state.roles = roles
  },
  [GET_ROLE] (state, role) {
    state.role = role
  }
}



// WEBPACK FOOTER //
// ./src/components/role/store/mutations.js